export default "__VITE_ASSET__7UmiD25s__"